// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"36869cd0","499":"b749902e"}[chunkId] + ".chunk.css";
};